module.exports = {
  "dateRange": function dateRange(args) {
    return "".concat(args.startDate, " \u2014 ").concat(args.endDate);
  },
  "dateSelected": function dateSelected(args) {
    return "\u0412\u0438\u0431\u0440\u0430\u043D\u043E ".concat(args.date);
  },
  "finishRangeSelectionPrompt": "\u041D\u0430\u0442\u0438\u0441\u043D\u0456\u0442\u044C, \u0449\u043E\u0431 \u0437\u0430\u0432\u0435\u0440\u0448\u0438\u0442\u0438 \u0432\u0438\u0431\u0456\u0440 \u0434\u0456\u0430\u043F\u0430\u0437\u043E\u043D\u0443 \u0434\u0430\u0442",
  "maximumDate": "\u041E\u0441\u0442\u0430\u043D\u043D\u044F \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0430 \u0434\u0430\u0442\u0430",
  "minimumDate": "\u041F\u0435\u0440\u0448\u0430 \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0430 \u0434\u0430\u0442\u0430",
  "next": "\u041D\u0430\u0441\u0442\u0443\u043F\u043D\u0438\u0439",
  "previous": "\u041F\u043E\u043F\u0435\u0440\u0435\u0434\u043D\u0456\u0439",
  "selectedDateDescription": function selectedDateDescription(args) {
    return "\u0412\u0438\u0431\u0440\u0430\u043D\u0430 \u0434\u0430\u0442\u0430: ".concat(args.date);
  },
  "selectedRangeDescription": function selectedRangeDescription(args) {
    return "\u0412\u0438\u0431\u0440\u0430\u043D\u0438\u0439 \u0434\u0456\u0430\u043F\u0430\u0437\u043E\u043D: ".concat(args.dateRange);
  },
  "startRangeSelectionPrompt": "\u041D\u0430\u0442\u0438\u0441\u043D\u0456\u0442\u044C, \u0449\u043E\u0431 \u043F\u043E\u0447\u0430\u0442\u0438 \u0432\u0438\u0431\u0456\u0440 \u0434\u0456\u0430\u043F\u0430\u0437\u043E\u043D\u0443 \u0434\u0430\u0442",
  "todayDate": function todayDate(args) {
    return "\u0421\u044C\u043E\u0433\u043E\u0434\u043D\u0456, ".concat(args.date);
  },
  "todayDateSelected": function todayDateSelected(args) {
    return "\u0421\u044C\u043E\u0433\u043E\u0434\u043D\u0456, \u0432\u0438\u0431\u0440\u0430\u043D\u043E ".concat(args.date);
  }
};